(function () {
    'use strict';

    angular.module('app.trendyolIntegration', [
        // Angular modules
        'ngRoute',

        // Custom modules
        'treeControl'
        // 3rd Party Modules

    ]);
})();